// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src//assets/icons/chevron-down.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navigation-link:hover::after {
    width: 100%;
    height: 100%;
    opacity: 1;
    border-radius: 5px;
    left: 0;
    top: 0;
}
.navigation-link::after {
    content: "";
    width: 0%;
    height: 0%;
    position: absolute;
    left: 50%;
    top: 50%;
    border-radius: 50%;
    background-color: #ffffff0f;
    opacity: 0.5;
    transition: all 300ms ease-in-out;
}
.navigation-link {
    position: relative;
}
table {
    border-radius: 15px;
    border-style: hidden;
    box-shadow: 0 0 0 1px #F3F3F3;
    overflow: clip;
}

.bar-container {
    width: 100%;
    height: 27vh;
    position: relative;
  }


  .check-container {
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 22px;
    -webkit-user-select: none;
    user-select: none;
  }
  
  /* Hide the browser's default checkbox */
  .check-container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  
  /* Create a custom checkbox */
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #F3F3F3;
    border: 1px #2121F11A solid;
    border-radius: 2px;
  }
  
  /* On mouse-over, add a grey background color */
  .check-container:hover input ~ .checkmark {
    background-color: #ccc;
  }
  
  /* When the checkbox is checked, add a blue background */
  .check-container input:checked ~ .checkmark {
    background-color: #1B0A4B;
  }
  
  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }
  
  /* Show the checkmark when checked */
  .check-container input:checked ~ .checkmark:after {
    display: block;
  }
  
  /* Style the checkmark/indicator */
  .check-container .checkmark:after {
    left: 6px;
    top: 3px;
    width: 5px;
    height: 8px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(35deg);
  }
  .customer_box {
    position: relative;
  }
  .customer_box::after {
    content: "";
    width: 106.8%;
    left: -3.4%;
    position: absolute;
    bottom: -10px;
    height: 0.8px;
    background-color: #BDBDBD;
  }
  .customer_box a {
    position: relative;
    width: fit-content;
    transition: var(--transition);
  }
  .customer_box .b-active::after {

    width: 100%;
    z-index: 1;
    background-color: #2121F1;
  }
  .customer_box a::after {
    content: "";
    position: absolute;
    height: 2px;
    width: 0%;
    transition: all 500ms cubic-bezier(0, 0.15, 0, 1.1);
    bottom: -18px;
    left: 0px;
  }
  .settings-box a::after {
    content: "";
    position: absolute;
    height: 2px;
    width: 0%;
    transition: all 500ms cubic-bezier(0, 0.15, 0, 1.1);
    bottom: -8px;
    left: 0px;
  }

  [aria-disabled="true"] {
    opacity: 0.5;
  }

  select {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    outline: none; /* Remove default focus outline */
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* Replace "arrow.png" with the path to your arrow image */
    background-repeat: no-repeat;
    background-position: 95% 50%; /* Adjust the right padding of the arrow */
    background-size: 19px;
  }
  select::after {
    content: "\\25BC"; /* Unicode arrow down character */
    position: absolute;
    top: 50%;
    right: 15px; /* Adjust the right padding of the arrow */
    transform: translateY(-50%);
    font-size: 16px;
    pointer-events: none; /* Ensure the arrow doesn't interfere with clicking the select */
  }
  
  /* Hide default arrow in certain browsers */
  select::-ms-expand {
    display: none;
  }
  .category-wrapper .product-grid-wrapper {
    grid-template-columns: repeat(auto-fit, minmax(170px, 1fr)) !important;
  }
  .category-wrapper .product-wrapper {
    width: 168px !important;
  }

  .--box-shadow {
    box-shadow: 0px 0px 3px 1px #00000018;
    background-color: white;
    padding: 8px;
    border-radius: 8px
  }

  .--search-box {
    box-shadow: 0px 2px 9px 0px #00000008;
    -webkit-user-select: none;
            user-select: none;
  }`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,OAAO;IACP,MAAM;AACV;AACA;IACI,WAAW;IACX,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,kBAAkB;IAClB,2BAA2B;IAC3B,YAAY;IACZ,iCAAiC;AACrC;AACA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;;EAGA;IACE,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,yBAAyB;IAGzB,iBAAiB;EACnB;;EAEA,wCAAwC;EACxC;IACE,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,SAAS;IACT,QAAQ;EACV;;EAEA,6BAA6B;EAC7B;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,2BAA2B;IAC3B,kBAAkB;EACpB;;EAEA,+CAA+C;EAC/C;IACE,sBAAsB;EACxB;;EAEA,wDAAwD;EACxD;IACE,yBAAyB;EAC3B;;EAEA,6DAA6D;EAC7D;IACE,WAAW;IACX,kBAAkB;IAClB,aAAa;EACf;;EAEA,oCAAoC;EACpC;IACE,cAAc;EAChB;;EAEA,kCAAkC;EAClC;IACE,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IAGzB,wBAAwB;EAC1B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,yBAAyB;EAC3B;EACA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,6BAA6B;EAC/B;EACA;;IAEE,WAAW;IACX,UAAU;IACV,yBAAyB;EAC3B;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,mDAAmD;IACnD,aAAa;IACb,SAAS;EACX;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,mDAAmD;IACnD,YAAY;IACZ,SAAS;EACX;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,aAAa,EAAE,iCAAiC;IAChD,yDAA4D,EAAE,0DAA0D;IACxH,4BAA4B;IAC5B,4BAA4B,EAAE,0CAA0C;IACxE,qBAAqB;EACvB;EACA;IACE,gBAAgB,EAAE,iCAAiC;IACnD,kBAAkB;IAClB,QAAQ;IACR,WAAW,EAAE,0CAA0C;IACvD,2BAA2B;IAC3B,eAAe;IACf,oBAAoB,EAAE,gEAAgE;EACxF;;EAEA,2CAA2C;EAC3C;IACE,aAAa;EACf;EACA;IACE,sEAAsE;EACxE;EACA;IACE,uBAAuB;EACzB;;EAEA;IACE,qCAAqC;IACrC,uBAAuB;IACvB,YAAY;IACZ;EACF;;EAEA;IACE,qCAAqC;IACrC,yBAAiB;YAAjB,iBAAiB;EACnB","sourcesContent":[".navigation-link:hover::after {\n    width: 100%;\n    height: 100%;\n    opacity: 1;\n    border-radius: 5px;\n    left: 0;\n    top: 0;\n}\n.navigation-link::after {\n    content: \"\";\n    width: 0%;\n    height: 0%;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    border-radius: 50%;\n    background-color: #ffffff0f;\n    opacity: 0.5;\n    transition: all 300ms ease-in-out;\n}\n.navigation-link {\n    position: relative;\n}\ntable {\n    border-radius: 15px;\n    border-style: hidden;\n    box-shadow: 0 0 0 1px #F3F3F3;\n    overflow: clip;\n}\n\n.bar-container {\n    width: 100%;\n    height: 27vh;\n    position: relative;\n  }\n\n\n  .check-container {\n    display: block;\n    position: relative;\n    padding-left: 35px;\n    margin-bottom: 12px;\n    cursor: pointer;\n    font-size: 22px;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n  }\n  \n  /* Hide the browser's default checkbox */\n  .check-container input {\n    position: absolute;\n    opacity: 0;\n    cursor: pointer;\n    height: 0;\n    width: 0;\n  }\n  \n  /* Create a custom checkbox */\n  .checkmark {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 20px;\n    width: 20px;\n    background-color: #F3F3F3;\n    border: 1px #2121F11A solid;\n    border-radius: 2px;\n  }\n  \n  /* On mouse-over, add a grey background color */\n  .check-container:hover input ~ .checkmark {\n    background-color: #ccc;\n  }\n  \n  /* When the checkbox is checked, add a blue background */\n  .check-container input:checked ~ .checkmark {\n    background-color: #1B0A4B;\n  }\n  \n  /* Create the checkmark/indicator (hidden when not checked) */\n  .checkmark:after {\n    content: \"\";\n    position: absolute;\n    display: none;\n  }\n  \n  /* Show the checkmark when checked */\n  .check-container input:checked ~ .checkmark:after {\n    display: block;\n  }\n  \n  /* Style the checkmark/indicator */\n  .check-container .checkmark:after {\n    left: 6px;\n    top: 3px;\n    width: 5px;\n    height: 8px;\n    border: solid white;\n    border-width: 0 2px 2px 0;\n    -webkit-transform: rotate(35deg);\n    -ms-transform: rotate(35deg);\n    transform: rotate(35deg);\n  }\n  .customer_box {\n    position: relative;\n  }\n  .customer_box::after {\n    content: \"\";\n    width: 106.8%;\n    left: -3.4%;\n    position: absolute;\n    bottom: -10px;\n    height: 0.8px;\n    background-color: #BDBDBD;\n  }\n  .customer_box a {\n    position: relative;\n    width: fit-content;\n    transition: var(--transition);\n  }\n  .customer_box .b-active::after {\n\n    width: 100%;\n    z-index: 1;\n    background-color: #2121F1;\n  }\n  .customer_box a::after {\n    content: \"\";\n    position: absolute;\n    height: 2px;\n    width: 0%;\n    transition: all 500ms cubic-bezier(0, 0.15, 0, 1.1);\n    bottom: -18px;\n    left: 0px;\n  }\n  .settings-box a::after {\n    content: \"\";\n    position: absolute;\n    height: 2px;\n    width: 0%;\n    transition: all 500ms cubic-bezier(0, 0.15, 0, 1.1);\n    bottom: -8px;\n    left: 0px;\n  }\n\n  [aria-disabled=\"true\"] {\n    opacity: 0.5;\n  }\n\n  select {\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    outline: none; /* Remove default focus outline */\n    background-image: url(\"/src//assets/icons/chevron-down.svg\"); /* Replace \"arrow.png\" with the path to your arrow image */\n    background-repeat: no-repeat;\n    background-position: 95% 50%; /* Adjust the right padding of the arrow */\n    background-size: 19px;\n  }\n  select::after {\n    content: \"\\25BC\"; /* Unicode arrow down character */\n    position: absolute;\n    top: 50%;\n    right: 15px; /* Adjust the right padding of the arrow */\n    transform: translateY(-50%);\n    font-size: 16px;\n    pointer-events: none; /* Ensure the arrow doesn't interfere with clicking the select */\n  }\n  \n  /* Hide default arrow in certain browsers */\n  select::-ms-expand {\n    display: none;\n  }\n  .category-wrapper .product-grid-wrapper {\n    grid-template-columns: repeat(auto-fit, minmax(170px, 1fr)) !important;\n  }\n  .category-wrapper .product-wrapper {\n    width: 168px !important;\n  }\n\n  .--box-shadow {\n    box-shadow: 0px 0px 3px 1px #00000018;\n    background-color: white;\n    padding: 8px;\n    border-radius: 8px\n  }\n\n  .--search-box {\n    box-shadow: 0px 2px 9px 0px #00000008;\n    user-select: none;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
